import React from 'react';
import { Button, Input } from '@arco-design/web-react';
import { ReviewFields } from './types';
import { ActionButton, ReviewUiState, codePointLength, reasonIssue } from './reviewUiState';

export default function MessageActionBar({
  ui,
  fields,
  reasonLocked,
  onReasonChange,
  onPrimary,
  onSecondary,
  onWithdraw,
  onClose,
  onLocate
}: {
  ui: ReviewUiState;
  fields: ReviewFields;
  reasonLocked: boolean;
  onReasonChange: (value: string) => void;
  onPrimary: (action: ActionButton) => void;
  onSecondary: (action: ActionButton) => void;
  onWithdraw?: (action: ActionButton) => void;
  onClose: () => void;
  onLocate: () => void;
}) {
  const reason = reasonIssue(fields.reason);
  const showPublish = ui.analysisV2 && ui.primary.id !== 'publish' && ui.primary.id !== 'publish-update' && ui.primary.id !== 'none';
  const reasonCount = codePointLength(fields.reason);
  return (
    <div className="message-action-bar">
      {ui.showReason && (
        <label className="message-reason">
          操作原因
          <Input.TextArea
            id="review-field-reason"
            aria-label="操作原因"
            disabled={reasonLocked}
            placeholder="说明你核对了什么，或为什么执行本次操作"
            value={fields.reason}
            onChange={onReasonChange}
            autoSize={{ minRows: 2, maxRows: 3 }}
          />
          <span className="message-char-count">{reasonCount} / 2000</span>
          <span className="message-field-hint">此原因将记录在审核/发布/拦截记录中，不会展示在产品文章正文中。</span>
          {reason && ui.issues.some(item => item.field === 'reason') && <p className="message-field-error">{reason.message}</p>}
        </label>
      )}
      <div className="message-action-meta">
        {ui.missingCount > 0 && ui.analysisV2 ? (
          <p>
            {reason && ui.missingCount === 1 ? '填写操作原因后可保存' : `还需补全 ${ui.missingCount} 处`}
            <Button type="text" onClick={onLocate}>
              定位缺失项
            </Button>
          </p>
        ) : (
          <p>{ui.articleIssues.length === 0 && ui.progressLabel ? ui.progressLabel : ' '}</p>
        )}
        <span data-testid="publish-action-help">{ui.publishHelp}</span>
      </div>
      <div className="message-action-row">
        <div className="message-action-left">
          {ui.withdraw && (
            <Button status="danger" disabled={!ui.withdraw.enabled} onClick={() => onWithdraw?.(ui.withdraw!)}>
              {ui.withdraw.label}
            </Button>
          )}
        </div>
        <div className="message-action-right">
          <Button aria-label="关闭审核抽屉" onClick={onClose}>
            关闭
          </Button>
          {ui.secondary.map(action => (
            <Button key={action.id} disabled={!action.enabled} onClick={() => onSecondary(action)}>
              {action.label}
            </Button>
          ))}
          {showPublish && (
            <Button disabled={!ui.canPublish} onClick={() => onSecondary({ id: 'publish', label: '提交发布', enabled: ui.canPublish, help: ui.publishHelp })}>
              提交发布
            </Button>
          )}
          {ui.primary.label && (
            <Button
              type={ui.primary.primary || ui.primary.id !== 'none' ? 'primary' : 'secondary'}
              loading={ui.primary.loading}
              disabled={!ui.primary.enabled}
              onClick={() => onPrimary(ui.primary)}
            >
              {ui.primary.label}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
